// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.chat-message-editor-container {
  width: 100%;
  display: flex;
  flex-direction: column;
}

.chat-message-editor-textarea {
  resize: none;
  width: 100%;
  border-radius: unset;
  border-top-left-radius: var(--dialog-border-radius);
  border-top-right-radius: var(--dialog-border-radius);
}

.chat-message-editor-buttons {
  display: flex;
  flex-direction: row;
  border: 1px solid var(--border-color);
  border-top: none;
  border-bottom-left-radius: var(--dialog-border-radius);
  border-bottom-right-radius: var(--dialog-border-radius);
  background-color: var(--extra-light-grey);
  align-items: center;
}

.chat-message-editor-buttons .icon-button {
  border-radius: unset;
  border: none;
}

.chat-message-editor-send-button {
  border-bottom-right-radius: calc(
    var(--dialog-border-radius) - 1.5px
  ) !important;
}

.chat-message-editor-buttons-separator {
  width: 1px;
  height: calc(
    var(--input-element-height) - (var(--input-element-gap-small) * 2)
  );
  background-color: var(--border-color);
}
`, "",{"version":3,"sources":["webpack://./src/ui/views/session-view/side-panels/event-history-list/event-history-panel/chat-message-editor/ChatMessageEditor.component.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,oBAAoB;EACpB,mDAAmD;EACnD,oDAAoD;AACtD;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,qCAAqC;EACrC,gBAAgB;EAChB,sDAAsD;EACtD,uDAAuD;EACvD,yCAAyC;EACzC,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,YAAY;AACd;;AAEA;EACE;;cAEY;AACd;;AAEA;EACE,UAAU;EACV;;GAEC;EACD,qCAAqC;AACvC","sourcesContent":[".chat-message-editor-container {\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n}\n\n.chat-message-editor-textarea {\n  resize: none;\n  width: 100%;\n  border-radius: unset;\n  border-top-left-radius: var(--dialog-border-radius);\n  border-top-right-radius: var(--dialog-border-radius);\n}\n\n.chat-message-editor-buttons {\n  display: flex;\n  flex-direction: row;\n  border: 1px solid var(--border-color);\n  border-top: none;\n  border-bottom-left-radius: var(--dialog-border-radius);\n  border-bottom-right-radius: var(--dialog-border-radius);\n  background-color: var(--extra-light-grey);\n  align-items: center;\n}\n\n.chat-message-editor-buttons .icon-button {\n  border-radius: unset;\n  border: none;\n}\n\n.chat-message-editor-send-button {\n  border-bottom-right-radius: calc(\n    var(--dialog-border-radius) - 1.5px\n  ) !important;\n}\n\n.chat-message-editor-buttons-separator {\n  width: 1px;\n  height: calc(\n    var(--input-element-height) - (var(--input-element-gap-small) * 2)\n  );\n  background-color: var(--border-color);\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
